<template>
  <div class="row no-wrap justify-center items-center">
    <div class="delimiter"/>
    <vue-slider
      :value="value"
      :dot-size="25"
      direction="rtl"
      :min="min"
      :max="max"
      :interval="step"
      :height="2"
      :marks="marks"
      tooltip="always"
      style="width: 100%;"
      @change="v => $emit('input', v)">
      <template #tooltip="{ value }">
        <div class="text-riseup-white r-text-bold slider-tooltip r-text-regular">{{ formatAmountWithFraction(value, 0) }} ₪</div>
        <div class="slider-tooltip-line-container">
          <div class="slider-tooltip-line"/>
        </div>
      </template>
    </vue-slider>
    <div class="delimiter"/>
  </div>
</template>

<script>
import MoneyFormat from '@/mixins/MoneyFormat';

export default {
  name: 'DefaultSlider',
  mixins: [MoneyFormat],
  props: {
    value: Number,
    color: {
      type: String,
      default: 'primary',
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    step: {
      type: Number,
      default: 1,
    },
    labelValue: {
      type: String,
    },
    label: {
      type: Boolean,
      default: true,
    },
    labelAlways: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    marks() {
      return {
        [this.min]: this.formatAmountWithFraction(this.min, 0),
        [this.max]: this.formatAmountWithFraction(this.max, 0),
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/styles/riseup.brand";

.delimiter {
  height: 6px;
  width: 2px;
  background-color: $riseup-black;
}

</style>

<style lang="scss">
@import "src/styles/riseup.brand";

.vue-slider-dot-tooltip {
  .slider-tooltip {
    position: relative;
    bottom: -10px;
    padding: 8px 10px;
    border-radius: 2px;
    background-color: $riseup-blue;
    white-space: nowrap;
    text-align: center;
  }

  .slider-tooltip-line-container {
    position: relative;
    display: flex;
    justify-content: center;
    height: 30px;
    bottom: -10px;

    .slider-tooltip-line {
      width: 2px;
      background-color: $riseup-blue;
    }
  }
}

</style>
